import { render } from "./CommunityDistributionView.vue?vue&type=template&id=4facf44f&scoped=true&ts=true"
import script from "./CommunityDistributionView.vue?vue&type=script&lang=ts"
export * from "./CommunityDistributionView.vue?vue&type=script&lang=ts"

import "./CommunityDistributionView.vue?vue&type=style&index=0&id=4facf44f&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4facf44f"]])

export default __exports__